var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-1.5 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "up",
    d: "M3.69262 0.668936C3.85254 0.476885 4.14746 0.476885 4.30738 0.668936L6.91787 3.80384C7.13484 4.0644 6.94956 4.4598 6.61049 4.4598H1.38951C1.05044 4.4598 0.865158 4.0644 1.08213 3.80384L3.69262 0.668936Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "down",
    d: "M3.69262 10.3311C3.85254 10.5231 4.14746 10.5231 4.30738 10.3311L6.91787 7.19616C7.13484 6.9356 6.94956 6.5402 6.61049 6.5402H1.38951C1.05044 6.5402 0.865158 6.9356 1.08213 7.19616L3.69262 10.3311Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortOrder);
export default __webpack_public_path__ + "static/media/sort-order.9b42c7a4aab62c19f254441da8bcb8fc.svg";
export { ForwardRef as ReactComponent };